import { FC } from "react";
import { BaseTable2 } from "../../../../../TrueUI";
import {
  childContextMenu,
  columnOptionsForParentTableRowCells,
  getActivityTableConfiguration,
  parentContextMenu,
  tableName,
} from "../ActivityTabConstants";
import BaseTableDropdownFilter from "../../../../../TrueUI/Tables/BaseTableCommonFilters/BaseTableDropdownFilter";
import BaseTablePolicyDropdownAsyncFilter from "../../../../Policy/BaseTablePolicyDropdownAsyncFilter";
import { BaseTable2Properties } from "../../../../../TrueUI/Tables/BaseTable2/TableProperties";
import BaseTableGridForm from "../../../../../TrueUI/Tables/ComponentPatterns/BaseTableGridForm";
import { IconButton } from "@mui/material";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import MultiAlignHeader from "../../../../../TrueUI/Tables/MultiTable/MultiAlignHeader";
import { useBaseTable } from "../../../../../../hooks/useBaseTable";
import { BillingActivityTableWrapperProps } from "./TypesBillingActivityTable";

const BillingActivityTableWrapper: FC<BillingActivityTableWrapperProps> = ({
  insuredId,
  currentPolicy,
  customTableHeader,
  setCurrentPolicy,
  tabKey,
  setModalConfigForEditEntryAction,
}) => {
  const parentURL = `api/Activity/GetInsuredBillingActivityActivities/?insuredId=${insuredId}${
    currentPolicy !== null ? `&policyId=${currentPolicy}` : ""
  }`;
  const childURL =
    "api/Activity/GetInsuredBillingActivityActivitiesSub?insuredId=null&transactionId=null&amount=null";

  const activityConfig: BaseTable2Properties = {
    ...getActivityTableConfiguration(parentURL),
    filterOptions: [
      (actionOptions) =>
        BaseTablePolicyDropdownAsyncFilter({
          columnsNames: ["PolicyId"],
          insuredId: insuredId,
          filterOptions: actionOptions,
          showAllOption: false,
          selectWidth: "180px",
          onChange: (value) => {
            setCurrentPolicy(typeof value !== "number" ? null : value);
          },
          tabKey: tabKey,
        }),
      (actionOptions) =>
        BaseTableDropdownFilter({
          id: "line-filter",
          columnsNames: ["Line"],
          filterOptions: actionOptions,
          usingExternalFiltering: true,
          labelText: "Line of Coverage:",
          optionsOverride: [
            { displayName: "All", stringValue: "all" },
            { displayName: "WC", stringValue: "WC" },
          ],
          defaultValue: "all",
        }),
      () => customTableHeader,
    ],
    advancedOptions: {
      paginate: false,
      disableOrderBy: true,
      multiTableProperties: {
        MultiTablePatternComponent: (e) => {
          return (
            <BaseTableGridForm
              obj={e}
              urlPattern={childURL}
              parameters={[
                {
                  paramaterKey: "transactionId",
                  parameterPropertyValue: "TransactionId",
                },
                {
                  paramaterKey: "insuredId",
                  parameterPropertyValue: "InsuredId",
                },
                {
                  paramaterKey: "amount",
                  parameterPropertyValue: "Amount",
                },
              ]}
              childEditComponent={() => (
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() =>
                    setModalConfigForEditEntryAction({
                      showModalBillingItem: true,
                      activityType: "edit_entry",
                      transactionId: parseInt(e?.TransactionId ?? "0"),
                    })
                  }
                >
                  <ModeEditOutlineIcon fontSize="small" />
                </IconButton>
              )}
              contextMenu={childContextMenu}
              columnOptions={columnOptionsForParentTableRowCells}
            />
          );
        },
        MultiTableHeaderPatternComponent: (params, _metaData) => {
          //underscore will be removed in next PRs
          return (
            <MultiAlignHeader
              contextConfiguration={{
                contextMenu: parentContextMenu,
              }}
              headerParams={params ?? []}
              columnOptions={columnOptionsForParentTableRowCells}
            />
          );
        },
      },
      headerExportType: "aligned",
    },
  };

  useBaseTable(activityConfig);

  return <BaseTable2 name={tableName} />;
};

export default BillingActivityTableWrapper;
